import { useEffect, useState } from "react";
import { CreateFormTheme } from "../../utils/themes";
import { useTheme } from "../../middleware/ThemeContext";
import EditIcon from "../../assets/icons/EditIcon";
import styled from "styled-components";

const ScopeFlag = styled.div`
  background: #FFEAA6;
  color: #3B3B3B;
  border-radius: 30px;
  padding: 4px 8px;
  font-size: 14px;
  font-weight: 600;
  margin-right: 8px;
`;
export const EditableTitle: React.FC<{
    value: string;
    onChange: (newValue: string) => void;
    onPencilClick?: () => void;
    scopeLabel?: string;
}> = ({ value, onChange, onPencilClick, scopeLabel }) => {
    const { theme } = useTheme();
    const [editingValue, setEditingValue] = useState(value);
    const [isEditing, setIsEditing] = useState(false);

    const handleBlur = () => {
        setIsEditing(false);
        if (editingValue.trim() !== value) {
            onChange(editingValue.trim());
        }
    };
    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            handleBlur();
        }
    };

    useEffect(() => {
        setEditingValue(value);
    }, [value]);

    return isEditing ? (
        <input
            type="text"
            value={editingValue}
            onChange={(e) => setEditingValue(e.target.value)}
            onBlur={handleBlur}
            onKeyDown={handleKeyDown}
            autoFocus
            style={{
                fontSize: "16px",
                fontWeight: 600,
                color: theme.CreateFormTheme.colors.headerColor,
                background: "transparent",
                padding: "5px",
                width: "auto",
                fontFamily: "Raleway, sans-serif",
                backgroundColor: "#74BAFF",
                border: `1px solid ${theme.CreateFormTheme.colors.inputBorders}`,
            }} />
    ) : (
        <div
            onClick={() => setIsEditing(true)}
            style={{
                fontSize: "16px",
                fontWeight: 600,
                color: theme.CreateFormTheme.colors.headerColor,
                cursor: "pointer",
                padding: "5px",
                border: "1px dashed transparent",
                fontFamily: "Raleway, sans-serif",
            }}
        >
            {value}

            <span
                role="button"
                onClick={(e) => {
                    e.stopPropagation();
                    if (onPencilClick) {
                        onPencilClick();
                    } else {
                        setIsEditing(true);
                    }
                }}
                className="ms-2"
                style={{ display: 'inline-flex', verticalAlign: 'middle' }}
            >
                {scopeLabel && (
                    <ScopeFlag className="ms-2">{scopeLabel}</ScopeFlag>
                )}
                <EditIcon
                    color={theme.CorporateTheme?.colors?.textSecondary}
                    className="cursor-pointer"
                    size={24}
                />
            </span>
        </div>
    );
};